module.exports = __webpack_public_path__ + "img/white_lady.c9640531.jpg";